"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BentonSansFontFamilyName = 'Benton Sans';
exports.BentonSansLowDPIFontFamilyName = 'Benton Sans Low-DPI';
exports.BentonSansBookFontFaceName = 'Benton Sans Book';
exports.BentonSansBookItalicFontFaceName = 'Benton Sans Book Italic';
exports.BentonSansSemiDemiFontFaceName = 'Benton Sans SemiDemi';
exports.BentonSansSemiDemiItalicFontFaceName = 'Benton Sans SemiDemi Italic';
exports.BentonSansLightFontFaceName = 'Benton Sans Light';
exports.BentonSansMediumFontFaceName = 'Benton Sans Medium';
exports.SupportedBentonSansFontFaces = [
    exports.BentonSansBookFontFaceName,
    exports.BentonSansBookItalicFontFaceName,
    exports.BentonSansSemiDemiFontFaceName,
    exports.BentonSansSemiDemiItalicFontFaceName,
    exports.BentonSansLightFontFaceName,
    exports.BentonSansMediumFontFaceName,
];
//# sourceMappingURL=BentonSansFontNameConstants.js.map